/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_Username_PlaceholderInputs */

const en_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

const fr_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d’utilisateur`)
};

const de_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername`)
};

const it_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome utente`)
};

const ru_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя пользователя`)
};

const es_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de usuario`)
};

const zh_cn2_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户名`)
};

const ja_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名`)
};

const hi_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता नाम`)
};

const pt_pt2_work_order_publish_auth_username_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de usuário`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {Work_Order_Publish_Auth_Username_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_username_placeholder = /** @type {((inputs?: Work_Order_Publish_Auth_Username_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_Username_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "de") return de_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "it") return it_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "ru") return ru_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "es") return es_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "ja") return ja_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "hi") return hi_work_order_publish_auth_username_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_auth_username_placeholder(inputs)
	return en_work_order_publish_auth_username_placeholder(inputs)
});